import { Outlet } from 'react-router';

import Header from '../Header';
import { ContentContainer, LayoutContainer, MidSection } from './style';

const DefaultLayout = () => {
  return (
    <LayoutContainer>
      <Header />
      <MidSection>
        <ContentContainer>
          <Outlet />
        </ContentContainer>
      </MidSection>
    </LayoutContainer>
  );
};
export default DefaultLayout;
